import { authHeader, history } from "../_helpers";
import config from "../config";
import axios from "axios";
export const spotservellienceService = {
  getSpotType,
  createQrInformation,
  getQrInformation,
  getQrInformationById,
  getPatrollingPerson,
};

const baseUrl = config.apiGateway.baseUrl;
// const baseUrl = "https://www.criminalmis.in/api";

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  history.push("login");
}

function handleResponse(response) {
  if (response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    // location.reload(true);
  }

  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function getSpotType() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/spotservellience/getSpotTypes`, requestOptions).then(
    handleResponse
  );
}

function getPatrollingPerson() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/spotservellience/getPatrollingPerson`,
    requestOptions
  ).then(handleResponse);
}

function getQrInformation(cityId) {
  console.log("cityId", cityId);
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/spotservellience/getQrInformation/${cityId}`,
    requestOptions
  ).then(handleResponse);
}

function getQrInformationById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/spotservellience/getQrInformationbyid/${id}`,
    requestOptions
  ).then(handleResponse);
}

function createQrInformation(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/spotservellience/createQr`, requestOptions).then(
    handleResponse
  );
}
